import * as React from "react";

interface ListProps<T> {
    items: readonly T[];
    children: (item: T, index: number) => React.ReactNode;
}

const SimpleList = <T extends any>({ items, children: render }: ListProps<T>) => {
    return <React.Fragment>{items.map(render)}</React.Fragment>;
};

export default SimpleList;
